<template>
  <div class="unlogged-screen">
    <img v-if="isProduction" src="@/assets/toro.png" alt="Toro">
    <img v-else src="@/assets/toro-canary.png" alt="Toro">

    <br><br>

    <slot></slot>

  </div>
</template>

<script>
  export default {
    name: 'app-unlogged-layout',
    computed: {
      isProduction() {
        return location.origin === 'https://toro.heseya.com'
      }
    }
  }
</script>

<style lang="scss">
  .unlogged-screen {
    padding: 34px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    min-height: 100vh;
    box-sizing: border-box;

    @media screen and (min-width: #{$media-900}) {
      background-color: #fafafa;
    }

    &::after,
    &::before {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      width: 190px;
      height: 415px;
      opacity: 0.4;
      z-index: -1;
      background: url('../assets/pattern.png');

      @media screen and (min-width: #{$media-900}) {
        z-index: 1;
      }
    }

    &::after {
      top: auto;
      right: auto;
      left: 0;
      bottom: 0;
      transform: rotate(180deg)
    }

    img {
      margin-right: auto;
      height: 50px;

      @media screen and (min-width: #{$media-900}) {
        margin: 0;
        height: 70px;
      }
    }

    .center {
      display: block;
      text-align: center;
    }

    form {
      width: 100%;

      @media screen and (min-width: #{$media-900}) {
        max-width: 500px;
        margin: 0 auto;
        box-sizing: border-box;
        background-color: #fff;
        padding: 64px;
        border-radius: 32px;
        box-shadow: 2px 2px 6px #0002;
      }
    }

    .to-right {
      width: 100%;
      display: block;
      text-align: right;
    }

    .btn {
      width: 80%;
      margin: 0 auto;
    }

    h1 {
      font-size: 1.6em;
      font-weight: 500;
      margin-top: 0;

      span {
        color: $primaryColor;
      }
    }

    p {
      text-align: center;
    }

    h2 {
      font-weight: 300;
      margin: 0;
      font-size: 1.2em;
    }
  }
</style>
